export default __webpack_public_path__ + "static/media/Stone.caf61e75.png";